import httpService from '@/modules/common/services/httpService';

const paymentSettingsRoute = '/platform/v1/payment/settings';

const fetchSettings = async () => httpService.get(paymentSettingsRoute).then((res) => res.data?.data?.payment_settings);
const saveSettings = async (payload) => httpService.post(paymentSettingsRoute, payload).then((res) => res.data.data);
const updateDefaultCurrency = async () => httpService.put(`${paymentSettingsRoute}/update_default_currency`, {}).then((res) => res.data.data);
export default {
  fetchSettings,
  saveSettings,
  updateDefaultCurrency,
};
